export default __webpack_public_path__ + "static/media/akun_white.bbb992d4.svg";